import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

console.log('Rendering TestimonialSection');

const TestimonialSection = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const testimonials = [
  {
    id: 1,
    name: "Sarah Chen",
    role: "CTO, TechVenture Labs",
    company: "TechVenture Labs",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f1230b9d-1763294070661.png",
    imageAlt: "Professional Asian woman with long black hair wearing navy blue blazer smiling confidently in modern office setting",
    content: "Michael transformed our legacy system into a scalable platform that handles 10x our previous traffic. His ability to understand business requirements and translate them into technical solutions is exceptional. The project was delivered on time and exceeded our performance expectations.",
    rating: 5,
    projectType: "Platform Modernization"
  },
  {
    id: 2,
    name: "David Martinez",
    role: "Founder & CEO, HealthSync",
    company: "HealthSync",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c639d38e-1763294070431.png",
    imageAlt: "Hispanic male entrepreneur with short dark hair and beard wearing white shirt smiling warmly in bright startup office",
    content: "Working with Michael was a game-changer for our startup. He built our HIPAA-compliant patient portal from scratch, handling complex security requirements with ease. His proactive communication and problem-solving skills made the entire process smooth. Highly recommend for healthcare tech projects.",
    rating: 5,
    projectType: "Healthcare Platform"
  },
  {
    id: 3,
    name: "Emily Thompson",
    role: "VP of Engineering, CloudScale",
    company: "CloudScale Inc",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f8f896f2-1763299689286.png",
    imageAlt: "Caucasian woman with blonde hair in professional gray suit jacket smiling confidently against modern glass office background",
    content: "Michael's expertise in building real-time systems is outstanding. He architected our WebSocket infrastructure that now handles 50K+ concurrent users without breaking a sweat. His code quality and documentation standards set a new benchmark for our engineering team.",
    rating: 5,
    projectType: "Real-Time Infrastructure"
  },
  {
    id: 4,
    name: "James Wilson",
    role: "Product Director, FinanceHub",
    company: "FinanceHub",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_18d854688-1763295573707.png",
    imageAlt: "African American man with short hair wearing dark blue suit and tie smiling professionally in corporate office environment",
    content: "The payment gateway Michael built for us processes millions in transactions daily with zero downtime. His attention to security details and performance optimization is remarkable. He's not just a developer; he's a strategic technical partner who understands business impact.",
    rating: 5,
    projectType: "Payment Systems"
  }];


  const currentTestimonial = testimonials?.[activeTestimonial];

  const handleNext = () => {
    setActiveTestimonial((prev) => (prev + 1) % testimonials?.length);
  };

  const handlePrev = () => {
    setActiveTestimonial((prev) => (prev - 1 + testimonials?.length) % testimonials?.length);
  };

  return (
    <section className="py-16 md:py-20 lg:py-24 bg-card">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground mb-4">
            Client Success Stories
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Real feedback from real clients who've experienced production-grade results
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-background rounded-2xl p-6 md:p-8 lg:p-12 border border-border shadow-xl">
            <div className="flex flex-col lg:flex-row gap-6 md:gap-8 items-center lg:items-start">
              <div className="flex-shrink-0">
                <div className="relative w-24 h-24 md:w-32 md:h-32 rounded-full overflow-hidden border-4 border-primary/20">
                  <Image
                    src={currentTestimonial?.image}
                    alt={currentTestimonial?.imageAlt}
                    className="w-full h-full object-cover" />

                </div>
              </div>

              <div className="flex-1 text-center lg:text-left">
                <div className="flex justify-center lg:justify-start gap-1 mb-4">
                  {[...Array(currentTestimonial?.rating)]?.map((_, i) =>
                  <Icon key={i} name="Star" size={20} color="var(--color-warning)" className="fill-current" />
                  )}
                </div>

                <blockquote className="text-base md:text-lg text-foreground mb-6 leading-relaxed">
                  "{currentTestimonial?.content}"
                </blockquote>

                <div className="space-y-2">
                  <div className="font-bold text-lg md:text-xl text-foreground">
                    {currentTestimonial?.name}
                  </div>
                  <div className="text-sm md:text-base text-muted-foreground">
                    {currentTestimonial?.role}
                  </div>
                  <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-xs md:text-sm font-medium">
                    <Icon name="Briefcase" size={14} />
                    <span>{currentTestimonial?.projectType}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-4 mt-8">
            <button
              onClick={handlePrev}
              className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-muted hover:bg-primary hover:text-primary-foreground transition-all duration-300"
              aria-label="Previous testimonial">

              <Icon name="ChevronLeft" size={20} />
            </button>

            <div className="flex gap-2">
              {testimonials?.map((_, index) =>
              <button
                key={index}
                onClick={() => setActiveTestimonial(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                index === activeTestimonial ?
                'bg-primary w-8' : 'bg-muted-foreground/30 hover:bg-muted-foreground/50'}`
                }
                aria-label={`View testimonial ${index + 1}`} />

              )}
            </div>

            <button
              onClick={handleNext}
              className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-muted hover:bg-primary hover:text-primary-foreground transition-all duration-300"
              aria-label="Next testimonial">

              <Icon name="ChevronRight" size={20} />
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-12 md:mt-16">
          {[
          { value: "98%", label: "Client Satisfaction" },
          { value: "150+", label: "Projects Completed" },
          { value: "50+", label: "Happy Clients" },
          { value: "8+", label: "Years Experience" }]?.
          map((stat, index) =>
          <div key={index} className="text-center p-4 md:p-6 bg-background rounded-lg border border-border">
              <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-primary mb-2">
                {stat?.value}
              </div>
              <div className="text-xs md:text-sm text-muted-foreground">
                {stat?.label}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default TestimonialSection;